import axios from "axios";
import { Notify } from "vant";
import router from "../router";
import { getConfig } from "./logClientType";
import loginCache from "@/utils/loginCache";
const service = axios.create({
  // 超时时间 单位是ms，
  // timeout: 30 * 1000
  timeout: 0
});
service.interceptors.request.use(
  async config => {
    config.data = JSON.stringify(config.data);
    let token = loginCache.getCache();
    let myClientType = getConfig();
    if (config.url == "https://apipxb.1v1jy.com/api/user/smsCode") {
      config.headers = {
        "Content-Type": "application/json",
        ClientType: myClientType
      };
    } else {
      config.headers = {
        "Content-Type": "application/json",
        ClientType: myClientType,
        Authorization: token
      };
    }
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  response => {
    if (response.data.code !== "10000") {
      Notify({
        message: response.data.message,
        color: "#ad0000",
        background: "#ffe1e1",
        duration: 3000
      });
      return Promise.reject("error");
    } else {
      return response.data;
    }
  },
  error => {
    /***** 接收到异常响应的处理开始 *****/
    if (error && error.response) {
      console.log(error.response);
      if (error.response.status == 401) {
        console.log("未登录");
        loginCache.removeCache();
        localStorage.removeItem("tenantNols");
        let myClientType = getConfig();
        if (myClientType === 1) {
          router.replace({ path: "/loginOut" });
        } else if (myClientType === 4) {
          router.replace({ path: "/loginPhone" });
        } else if (myClientType === 5) {
          router.replace({ path: "/loginPhoneIos" });
        } else {
          router.replace({ path: "/loginOut" });
        }

        if (error.response.data && error.response.data.msg) {
          Notify({ message: error.response.data.msg, duration: 5000 });
        } else {
          Notify({ message: "登录信息失效，请重新登录！", duration: 5000 });
        }
      } else {
        Notify({
          message: `${error.response.status}系统繁忙，请稍后再试`,
          color: "#ad0000",
          background: "#ffe1e1",
          duration: 3000
        });
      }
    }

    /***** 处理结束 *****/
    return Promise.resolve(error.response);
  }
);
export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js